
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import Logo from "@/components/common/Logo";
import { useSafeAreaInsets } from "@/hooks/useSafeAreaInsets";
import { cn } from "@/lib/utils";

const PricingHeader = () => {
  const { topPadding } = useSafeAreaInsets();
  return (
    <header className={cn("border-b border-border", topPadding)}>
      <div className="container mx-auto px-4 py-4 flex justify-between items-center">
        <Link to="/">
          <Logo size="medium" />
        </Link>
        <div className="space-x-4">
          <Link to="/seller/login">
            <Button variant="outline" className="border-godyspo-gold text-godyspo-gold">Login</Button>
          </Link>
          <Link to="/seller/register">
            <Button className="bg-godyspo-gold text-godyspo-background hover:bg-godyspo-gold/90">
              Get Started
            </Button>
          </Link>
        </div>
      </div>
    </header>
  );
};

export default PricingHeader;
